// import React, { useState, useEffect } from 'react';
// import '../styles/EESExperience.css';

// const EESExperience = ({ userData }) => {
//     const [responses, setResponses] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [stats, setStats] = useState({ answered: 0, total: 100 });

//     const surveyData = [
//         { category: "Overall Experience", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
//         { category: "Work Environment", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
//         { category: "Leadership & Management", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
//         { category: "Engagement & Motivation", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
//         { category: "Growth & Development", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
//         { category: "Compensation & Benefits", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
//         { category: "Work-Life Balance & Wellbeing", questions: ["I can disconnect from work hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
//         { category: "Inclusion & Belonging", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
//         { category: "Communication & Feedback", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
//         { category: "Exit Risk & Retention", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
//     ];

//     const handleSelect = (qKey, val) => {
//         const updated = { ...responses, [qKey]: val };
//         setResponses(updated);
//         setStats({ ...stats, answered: Object.keys(updated).length });
//     };

//     const submitSurvey = () => {
//         if (stats.answered < stats.total) {
//             alert(`Incomplete: Please answer ${stats.total - stats.answered} more questions.`);
//             return;
//         }
//         setSubmitted(true);
//     };

//     if (submitted) return (
//         <div className="ees-success-wrap">
//             <div className="ees-card success-card">
//                 <div className="icon-pulse">✨</div>
//                 <h2>Thank You, {userData.firstName}</h2>
//                 <p>Your 100-point experience profile has been successfully submitted.</p>
//                 <button className="ees-primary-btn" onClick={() => window.location.reload()}>Return Home</button>
//             </div>
//         </div>
//     );

//     return (
//         <div className="ees-layout">
//             <div className="ees-nav-header">
//                 <div className="brand">GENESIS <span className="sub">EES 2025</span></div>
//                 <div className="stats-box">
//                     <div className="progress-bar-wrap">
//                         <div className="progress-fill" style={{ width: `${(stats.answered / stats.total) * 100}%` }}></div>
//                     </div>
//                     <span className="count">{stats.answered} / {stats.total} COMPLETED</span>
//                 </div>
//                 <button className="ees-submit-btn" onClick={submitSurvey}>SUBMIT NOW</button>
//             </div>

//             <div className="ees-scroll-area">
//                 {surveyData.map((section, sIdx) => (
//                     <div key={sIdx} className="ees-category-group">
//                         <h3 className="cat-title">{section.category}</h3>
//                         {section.questions.map((q, qIdx) => {
//                             const qKey = `q-${sIdx}-${qIdx}`;
//                             return (
//                                 <div key={qIdx} className={`ees-question-row ${responses[qKey] ? 'is-answered' : ''}`}>
//                                     <div className="q-content">
//                                         <span className="index">{sIdx * 10 + qIdx + 1}</span>
//                                         <p className="text">{q}</p>
//                                     </div>
//                                     <div className="score-selector">
//                                         {[1, 2, 3, 4, 5].map(num => (
//                                             <button 
//                                                 key={num} 
//                                                 className={`score-bubble ${responses[qKey] === num ? 'selected' : ''}`}
//                                                 onClick={() => handleSelect(qKey, num)}
//                                             >
//                                                 {num}
//                                             </button>
//                                         ))}
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default EESExperience;




// import React, { useState } from 'react';
// import '../styles/EESExperience.css';

// const EESExperience = ({ userData }) => {
//     const [responses, setResponses] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [activeTab, setActiveTab] = useState(0);

//     const surveyData = [
//         { cat: "Overall Experience", icon: "🌌", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
//         { cat: "Work Environment", icon: "🛰️", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
//         { cat: "Leadership", icon: "👑", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
//         { cat: "Motivation", icon: "🚀", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
//         { cat: "Growth", icon: "📈", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
//         { cat: "Rewards", icon: "💰", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
//         { cat: "Wellbeing", icon: "🧘", questions: ["I can disconnect from work after hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
//         { cat: "Belonging", icon: "🤝", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
//         { cat: "Feedback", icon: "💬", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
//         { cat: "Retention", icon: "🛡️", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
//     ];

//     const handleSelect = (qIdx, val) => {
//         setResponses({ ...responses, [`${activeTab}-${qIdx}`]: val });
//     };

//     const progress = Math.round((Object.keys(responses).length / 100) * 100);

//     return (
//         <div className="ees-premium-container">
//             {/* Top Navigation Bar */}
//             <div className="ees-glass-nav">
//                 <div className="nav-info">
//                     <h2>EES 2025 // <span className="highlight">CORE_ANALYSIS</span></h2>
//                     <p>{userData.firstName} | {userData.employeeId}</p>
//                 </div>
//                 <div className="nav-progress-circle">
//                     <svg viewBox="0 0 36 36">
//                         <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                         <path className="circle" strokeDasharray={`${progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                     </svg>
//                     <span>{progress}%</span>
//                 </div>
//                 <button className={`final-submit-btn ${progress === 100 ? 'ready' : ''}`} onClick={() => setSubmitted(true)}>FINALIZE</button>
//             </div>

//             <div className="ees-main-stage">
//                 {/* Side Category Selector */}
//                 <div className="category-sidebar">
//                     {surveyData.map((item, index) => (
//                         <button 
//                             key={index} 
//                             className={`cat-btn ${activeTab === index ? 'active' : ''}`}
//                             onClick={() => setActiveTab(index)}
//                         >
//                             <span className="icon">{item.icon}</span>
//                             <span className="label">{item.cat}</span>
//                         </button>
//                     ))}
//                 </div>

//                 {/* Question Area */}
//                 <div className="question-stage">
//                     <div className="stage-header">
//                         <h1>{surveyData[activeTab].cat}</h1>
//                         <span>SECTOR_{activeTab + 1}</span>
//                     </div>
                    
//                     <div className="question-grid-container">
//                         {surveyData[activeTab].questions.map((q, i) => (
//                             <div key={i} className="glass-q-card">
//                                 <p>{q}</p>
//                                 <div className="rating-bubbles">
//                                     {[1, 2, 3, 4, 5].map(num => (
//                                         <button 
//                                             key={num}
//                                             className={`bubble ${responses[`${activeTab}-${i}`] === num ? 'selected' : ''}`}
//                                             onClick={() => handleSelect(i, num)}
//                                         >
//                                             {num}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EESExperience;








// third

// import React, { useState } from 'react';
// import '../styles/EESExperience.css';

// const EESExperience = ({ userData }) => {
//     const [responses, setResponses] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [activeTab, setActiveTab] = useState(0);

//     const surveyData = [
//         { cat: "Overall Experience", icon: "🌌", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
//         { cat: "Work Environment", icon: "🛰️", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
//         { cat: "Leadership", icon: "👑", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
//         { cat: "Motivation", icon: "🚀", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
//         { cat: "Growth", icon: "📈", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
//         { cat: "Rewards", icon: "💰", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
//         { cat: "Wellbeing", icon: "🧘", questions: ["I can disconnect from work after hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
//         { cat: "Belonging", icon: "🤝", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
//         { cat: "Feedback", icon: "💬", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
//         { cat: "Retention", icon: "🛡️", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
//     ];

//     const handleSelect = (qIdx, val) => {
//         setResponses({ ...responses, [`${activeTab}-${qIdx}`]: val });
//     };

//     const progress = Math.round((Object.keys(responses).length / 100) * 100);

//     if (submitted) return (
//         <div className="ees-success-screen">
//             <div className="success-card">
//                 <div className="check-icon">✓</div>
//                 <h1>Mission Accomplished</h1>
//                 <p>Your feedback has been successfully synchronized.</p>
//                 <button onClick={() => window.location.reload()}>Return to Dashboard</button>
//             </div>
//         </div>
//     );

//     return (
//         <div className="ees-premium-container">
//             {/* Top Navigation Bar */}
//             <div className="ees-glass-nav">
//                 <div className="nav-info">
//                     <h2><span className="highlight">Employee Experience Survey - EES</span></h2>
//                     <p>{userData.firstName} <span className="separator">|</span> {userData.employeeId}</p>
//                 </div>
//                 <div className="nav-center-progress">
//                     <div className="progress-label">System Progress</div>
//                     <div className="nav-progress-circle">
//                         <svg viewBox="0 0 36 36">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path className="circle" strokeDasharray={`${progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                         </svg>
//                         <span className="percent-text">{progress}%</span>
//                     </div>
//                 </div>
//                 <button 
//                     className={`final-submit-btn ${progress === 100 ? 'ready' : ''}`} 
//                     disabled={progress < 100}
//                     onClick={() => setSubmitted(true)}
//                 >
//                     {progress === 100 ? 'UPLOAD LOGS' : 'INCOMPLETE'}
//                 </button>
//             </div>

//             <div className="ees-main-stage">
//                 {/* Side Category Selector */}
//                 <div className="category-sidebar">
//                     {surveyData.map((item, index) => (
//                         <button 
//                             key={index} 
//                             className={`cat-btn ${activeTab === index ? 'active' : ''}`}
//                             onClick={() => setActiveTab(index)}
//                         >
//                             <span className="icon">{item.icon}</span>
//                             <span className="label">{item.cat}</span>
//                             {activeTab === index && <div className="active-glow"></div>}
//                         </button>
//                     ))}
//                 </div>

//                 {/* Question Area */}
//                 <div className="question-stage">
//                     <div className="stage-header">
//                         <div className="title-group">
//                             <small>DATA SECTOR {activeTab + 1}</small>
//                             <h1>{surveyData[activeTab].cat}</h1>
//                         </div>
//                         <div className="stage-stats">
//                             {surveyData[activeTab].questions.filter((_, i) => responses[`${activeTab}-${i}`]).length} / 10 Complete
//                         </div>
//                     </div>
                    
//                     <div className="question-grid-container">
//                         {surveyData[activeTab].questions.map((q, i) => (
//                             <div key={i} className={`glass-q-card ${responses[`${activeTab}-${i}`] ? 'answered' : ''}`}>
//                                 <div className="q-card-header">
//                                     <span className="q-number">{(activeTab * 10) + i + 1}</span>
//                                     <p>{q}</p>
//                                 </div>
//                                 <div className="rating-bubbles">
//                                     {[1, 2, 3, 4, 5].map(num => (
//                                         <button 
//                                             key={num}
//                                             className={`bubble bubble-${num} ${responses[`${activeTab}-${i}`] === num ? 'selected' : ''}`}
//                                             onClick={() => handleSelect(i, num)}
//                                         >
//                                             {num}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EESExperience;









// import React, { useState } from 'react';
// import '../styles/EESExperience.css';

// const EESExperience = ({ userData }) => {
//     const [responses, setResponses] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [activeTab, setActiveTab] = useState(0);

//     const surveyData = [
//         { cat: "Overall Experience", icon: "🌌", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
//         { cat: "Work Environment", icon: "🛰️", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
//         { cat: "Leadership", icon: "👑", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
//         { cat: "Motivation", icon: "🚀", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
//         { cat: "Growth", icon: "📈", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
//         { cat: "Rewards", icon: "💰", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
//         { cat: "Wellbeing", icon: "🧘", questions: ["I can disconnect from work after hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
//         { cat: "Belonging", icon: "🤝", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
//         { cat: "Feedback", icon: "💬", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
//         { cat: "Retention", icon: "🛡️", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
//     ];

//     const handleSelect = (qIdx, val) => {
//         setResponses({ ...responses, [`${activeTab}-${qIdx}`]: val });
//     };

//     // FIX: Calculate total questions dynamically (will result in 99)
//     const totalQuestions = surveyData.reduce((acc, curr) => acc + curr.questions.length, 0);
//     const answeredCount = Object.keys(responses).length;
    
//     // Progress calculation based on dynamic total
//     const progress = Math.round((answeredCount / totalQuestions) * 100);

  
//      if (submitted) return (
//     <div className="ees-success-screen">
//         <div className="success-card">
//             <div className="success-icon-wrap">
//                 <div className="success-check">✓</div>
//             </div>
//             <h1 className="success-title">Submission Successful</h1>
//             <p className="success-msg">Your neural feedback has been securely synchronized with the EES-2025 Database.</p>
//             <button className="success-close-btn" onClick={() => window.location.reload()}>
//                 RETURN TO DASHBOARD
//             </button>
//         </div>
//     </div>
// );

//     return (
//         <div className="ees-premium-container">
//             <div className="ees-glass-nav">
//                 <div className="nav-info">
//                     <h2><span className="highlight">Employee Experience Survey - EES</span></h2>
//                     <p>{userData.firstName} <span className="separator">|</span> {userData.employeeId}</p>
//                 </div>
//                 <div className="nav-center-progress">
//                     <div className="progress-label">System Progress</div>
//                     <div className="nav-progress-circle">
//                         <svg viewBox="0 0 36 36">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path className="circle" strokeDasharray={`${progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                         </svg>
//                         <span className="percent-text">{progress}%</span>
//                     </div>
//                 </div>
//                 <button 
//                     className={`final-submit-btn ${progress === 100 ? 'ready' : ''}`} 
//                     disabled={progress < 100}
//                     onClick={() => setSubmitted(true)}
//                 >
//                     {progress === 100 ? 'UPLOAD LOGS' : 'INCOMPLETE'}
//                 </button>
//             </div>

//             <div className="ees-main-stage">
//                 <div className="category-sidebar">
//                     {surveyData.map((item, index) => (
//                         <button 
//                             key={index} 
//                             className={`cat-btn ${activeTab === index ? 'active' : ''}`}
//                             onClick={() => setActiveTab(index)}
//                         >
//                             <span className="icon">{item.icon}</span>
//                             <span className="label">{item.cat}</span>
//                             {activeTab === index && <div className="active-glow"></div>}
//                         </button>
//                     ))}
//                 </div>

//                 <div className="question-stage">
//                     <div className="stage-header">
//                         <div className="title-group">
//                             <small>DATA SECTOR {activeTab + 1}</small>
//                             <h1>{surveyData[activeTab].cat}</h1>
//                         </div>
//                         <div className="stage-stats">
//                             {/* Updated to show actual question length for the current section (e.g., 9 for Retention) */}
//                             {surveyData[activeTab].questions.filter((_, i) => responses[`${activeTab}-${i}`]).length} / {surveyData[activeTab].questions.length} Complete
//                         </div>
//                     </div>
                    
//                     <div className="question-grid-container">
//                         {surveyData[activeTab].questions.map((q, i) => (
//                             <div key={i} className={`glass-q-card ${responses[`${activeTab}-${i}`] ? 'answered' : ''}`}>
//                                 <div className="q-card-header">
//                                     <span className="q-number">{(activeTab * 10) + i + 1}</span>
//                                     <p>{q}</p>
//                                 </div>
//                                 <div className="rating-bubbles">
//                                     {[1, 2, 3, 4, 5].map(num => (
//                                         <button 
//                                             key={num}
//                                             className={`bubble bubble-${num} ${responses[`${activeTab}-${i}`] === num ? 'selected' : ''}`}
//                                             onClick={() => handleSelect(i, num)}
//                                         >
//                                             {num}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EESExperience;









// import React, { useState } from 'react';
// import '../styles/EESExperience.css';

// // Added onFinalSubmit to the props destructuring
// const EESExperience = ({ userData, onFinalSubmit }) => {
//     const [responses, setResponses] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [activeTab, setActiveTab] = useState(0);

//     const surveyData = [
//         { cat: "Overall Experience", icon: "🌌", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
//         { cat: "Work Environment", icon: "🛰️", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
//         { cat: "Leadership", icon: "👑", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
//         { cat: "Motivation", icon: "🚀", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
//         { cat: "Growth", icon: "📈", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
//         { cat: "Rewards", icon: "💰", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
//         { cat: "Wellbeing", icon: "🧘", questions: ["I can disconnect from work after hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
//         { cat: "Belonging", icon: "🤝", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
//         { cat: "Feedback", icon: "💬", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
//         { cat: "Retention", icon: "🛡️", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
//     ];

//     const handleSelect = (qIdx, val) => {
//         setResponses({ ...responses, [`${activeTab}-${qIdx}`]: val });
//     };

//     const totalQuestions = surveyData.reduce((acc, curr) => acc + curr.questions.length, 0);
//     const answeredCount = Object.keys(responses).length;
//     const progress = Math.round((answeredCount / totalQuestions) * 100);

//     // Added the transmitData function as requested
//     // const transmitData = () => {
//     //     const finalPayload = {
//     //         id: userData.employeeId,
//     //         name: `${userData.firstName} ${userData.lastName}`,
//     //         dept: userData.department || "General",
//     //         date: new Date().toLocaleDateString(),
//     //         responses: responses, 
//     //         score: Math.round((Object.values(responses).reduce((a, b) => a + b, 0) / (totalQuestions * 5)) * 100) + "%"
//     //     };

//     //     if (onFinalSubmit) {
//     //         onFinalSubmit(finalPayload); 
//     //     }
//     //     setSubmitted(true);
//     // };

//     const transmitData = async () => {
//     const finalPayload = {
//         id: userData.employeeId,
//         name: `${userData.firstName} ${userData.lastName}`,
//         dept: userData.department || "General",
//         score: Math.round((Object.values(responses).reduce((a, b) => a + b, 0) / (totalQuestions * 5)) * 100) + "%",
//         responses: responses
//     };

//     try {
//         const response = await fetch('/gt-api/ees_api.php', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(finalPayload)
//         });
        
//         const result = await response.json();
//         if (result.status === "success") {
//             setSubmitted(true);
//         }
//     } catch (error) {
//         console.error("Database connection error:", error);
//         alert("System offline. Could not save feedback.");
//     }
// };

//     if (submitted) return (
//         <div className="ees-success-screen">
//             <div className="success-card">
//                 <div className="success-icon-wrap">
//                     <div className="success-check">✓</div>
//                 </div>
//                 <h1 className="success-title">Submission Successful</h1>
//                 <p className="success-msg">Your neural feedback has been securely synchronized with the EES-2025 Database.</p>
//                 <button className="success-close-btn" onClick={() => window.location.reload()}>
//                     RETURN TO DASHBOARD
//                 </button>
//             </div>
//         </div>
//     );

//     return (
//         <div className="ees-premium-container">
//             <div className="ees-glass-nav">
//                 <div className="nav-info">
//                     <h2><span className="highlight">Employee Experience Survey - EES</span></h2>
//                     <p>{userData.firstName} <span className="separator">|</span> {userData.employeeId}</p>
//                 </div>
//                 <div className="nav-center-progress">
//                     <div className="progress-label">System Progress</div>
//                     <div className="nav-progress-circle">
//                         <svg viewBox="0 0 36 36">
//                             <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                             <path className="circle" strokeDasharray={`${progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
//                         </svg>
//                         <span className="percent-text">{progress}%</span>
//                     </div>
//                 </div>
//                 <button 
//                     className={`final-submit-btn ${progress === 100 ? 'ready' : ''}`} 
//                     disabled={progress < 100}
//                     onClick={transmitData} // Changed from setSubmitted(true)
//                 >
//                     {progress === 100 ? 'UPLOAD LOGS' : 'INCOMPLETE'}
//                 </button>
//             </div>

//             <div className="ees-main-stage">
//                 <div className="category-sidebar">
//                     {surveyData.map((item, index) => (
//                         <button 
//                             key={index} 
//                             className={`cat-btn ${activeTab === index ? 'active' : ''}`}
//                             onClick={() => setActiveTab(index)}
//                         >
//                             <span className="icon">{item.icon}</span>
//                             <span className="label">{item.cat}</span>
//                             {activeTab === index && <div className="active-glow"></div>}
//                         </button>
//                     ))}
//                 </div>

//                 <div className="question-stage">
//                     <div className="stage-header">
//                         <div className="title-group">
//                             <small>DATA SECTOR {activeTab + 1}</small>
//                             <h1>{surveyData[activeTab].cat}</h1>
//                         </div>
//                         <div className="stage-stats">
//                             {surveyData[activeTab].questions.filter((_, i) => responses[`${activeTab}-${i}`]).length} / {surveyData[activeTab].questions.length} Complete
//                         </div>
//                     </div>
                    
//                     <div className="question-grid-container">
//                         {surveyData[activeTab].questions.map((q, i) => (
//                             <div key={i} className={`glass-q-card ${responses[`${activeTab}-${i}`] ? 'answered' : ''}`}>
//                                 <div className="q-card-header">
//                                     <span className="q-number">{(activeTab * 10) + i + 1}</span>
//                                     <p>{q}</p>
//                                 </div>
//                                 <div className="rating-bubbles">
//                                     {[1, 2, 3, 4, 5].map(num => (
//                                         <button 
//                                             key={num}
//                                             className={`bubble bubble-${num} ${responses[`${activeTab}-${i}`] === num ? 'selected' : ''}`}
//                                             onClick={() => handleSelect(i, num)}
//                                         >
//                                             {num}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EESExperience;




import React, { useState, useEffect } from 'react';
import '../styles/EESExperience.css';

const EESExperience = ({ userData, onFinalSubmit }) => {
    const [responses, setResponses] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const surveyData = [
        { cat: "Overall Experience", icon: "🌌", questions: ["My experience here meets my expectations.", "The company delivers on what it promises to employees.", "I feel emotionally connected to this organization.", "My job provides a sense of accomplishment.", "I feel optimistic about the company’s future.", "My role aligns well with my skills and interests.", "I feel energized when I start my workday.", "This organization treats employees fairly.", "I feel supported when challenges arise.", "My experience here has improved over time."] },
        { cat: "Work Environment", icon: "🛰️", questions: ["My workspace is comfortable and well-designed.", "Technology systems work reliably.", "Processes allow me to work efficiently.", "I experience minimal unnecessary interruptions.", "Team collaboration is encouraged.", "I have clarity on priorities.", "Physical working conditions are satisfactory.", "My role is clearly defined.", "I can focus without excessive distractions.", "Safety procedures are clearly communicated."] },
        { cat: "Leadership", icon: "👑", questions: ["My manager listens to my concerns.", "My manager treats everyone fairly.", "Leadership sets a clear vision.", "Leaders act in line with company values.", "I feel comfortable approaching leadership.", "My manager trusts me to do my job well.", "Leadership handles conflict effectively.", "Managers encourage open communication.", "Leadership decisions consider employee impact.", "I feel inspired by company leadership."] },
        { cat: "Motivation", icon: "🚀", questions: ["I feel enthusiastic about my work.", "My role challenges me in a positive way.", "I feel a strong sense of ownership in my work.", "My achievements are acknowledged.", "I understand how my work impacts the company.", "I am encouraged to share new ideas.", "I feel motivated by my team.", "My work aligns with my personal values.", "I feel driven to perform at my best.", "I feel engaged during most of my workday."] },
        { cat: "Growth", icon: "📈", questions: ["I receive guidance for career progression.", "My manager discusses growth opportunities with me.", "I have access to relevant learning resources.", "I am encouraged to build new skills.", "The company invests in employee development.", "I understand what is needed to advance.", "Job rotations or new projects are available.", "Mentorship opportunities are available.", "My development goals are supported.", "I feel challenged to grow professionally."] },
        { cat: "Rewards", icon: "💰", questions: ["Compensation reflects my performance.", "Benefits are communicated clearly.", "Pay reviews are conducted fairly.", "I understand my total rewards package.", "Incentives motivate strong performance.", "Benefits are competitive in the market.", "My compensation feels equitable internally.", "Non-monetary benefits are valuable.", "Salary increases are transparent.", "I feel financially valued by the company."] },
        { cat: "Wellbeing", icon: "🧘", questions: ["I can disconnect from work after hours.", "My manager respects personal time.", "I feel supported during stressful periods.", "Work demands are reasonable.", "The company promotes mental health awareness.", "I can take breaks without guilt.", "Flexible schedules are encouraged.", "I have time for personal priorities.", "I feel physically healthy at work.", "Burnout is actively addressed here."] },
        { cat: "Belonging", icon: "🤝", questions: ["I feel a strong sense of belonging.", "My ideas are taken seriously.", "I feel treated as an individual.", "I trust the company to handle bias fairly.", "Diversity is valued in hiring.", "Different cultures are respected.", "I feel safe speaking up.", "Inclusion is practiced, not just promoted.", "Team members support each other.", "Everyone has equal opportunities."] },
        { cat: "Feedback", icon: "💬", questions: ["Communication is clear and consistent.", "I know where to find important information.", "Changes are communicated effectively.", "I receive timely feedback.", "Leadership communicates honestly.", "Two-way communication is encouraged.", "Feedback is constructive and helpful.", "My suggestions are acknowledged.", "Meetings are productive.", "Information flow supports my work."] },
        { cat: "Retention", icon: "🛡️", questions: ["I feel secure in my job.", "I feel motivated to stay long-term.", "The company meets my career expectations.", "I see growth opportunities here.", "I feel loyal to this organization.", "I would choose this company again if given a choice.", "My manager influences my decision to stay positively.", "I feel my future is supported here.", "I believe staying here is good for my career."] }
    ];

    // UPDATED FUNCTION: Automatically moves to next tab when all questions in category are answered
   // UPDATED FUNCTION: Automatically moves to next tab and scrolls to top
    const handleSelect = (qIdx, val) => {
        const newResponses = { ...responses, [`${activeTab}-${qIdx}`]: val };
        setResponses(newResponses);

        // Calculate if all questions in the current section (usually 10) are answered
        const currentCategoryQuestions = surveyData[activeTab].questions;
        const isCategoryComplete = currentCategoryQuestions.every((_, index) => 
            newResponses[`${activeTab}-${index}`] !== undefined
        );

        // If complete and not on the last tab, move to next tab
        if (isCategoryComplete && activeTab < surveyData.length - 1) {
            setTimeout(() => {
                setActiveTab(prev => prev + 1);
                
                // This ensures the next section starts at the very first question
                window.scrollTo({ top: 0, behavior: 'smooth' });
                
                // If your questions are inside a scrollable div, we target that specifically:
                const questionContainer = document.querySelector('.question-stage');
                if (questionContainer) {
                    questionContainer.scrollTo({ top: 0, behavior: 'smooth' });
                }
            }, 600); // 600ms delay so the user sees their last selection before the jump
        }
    };

    const totalQuestions = surveyData.reduce((acc, curr) => acc + curr.questions.length, 0);
    const answeredCount = Object.keys(responses).length;
    const progress = Math.round((answeredCount / totalQuestions) * 100);

    const transmitData = async () => {
        const finalPayload = {
            id: userData.employeeId,
            name: `${userData.firstName} ${userData.lastName}`,
            dept: userData.department || "General",
            score: Math.round((Object.values(responses).reduce((a, b) => a + b, 0) / (totalQuestions * 5)) * 100) + "%",
            responses: responses
        };

        try {
            const response = await fetch('/gt-api/ees_api.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(finalPayload)
            });
            
            const result = await response.json();
            if (result.status === "success") {
                setSubmitted(true);
            }
        } catch (error) {
            console.error("Database connection error:", error);
            alert("System offline. Could not save feedback.");
        }
    };

    if (submitted) return (
        <div className="ees-success-screen">
            <div className="success-card">
                <div className="success-icon-wrap">
                    <div className="success-check">✓</div>
                </div>
                <h1 className="success-title">Submission Successful</h1>
                <p className="success-msg">Your neural feedback has been securely synchronized with the EES-2025 Database.</p>
                <button className="success-close-btn" onClick={() => window.location.reload()}>
                    RETURN TO DASHBOARD
                </button>
            </div>
        </div>
    );

    return (
        <div className="ees-premium-container">
            <div className="ees-glass-nav">
                <div className="nav-info">
                    <h2><span className="highlight">Employee Experience Survey - EES</span></h2>
                    <p>{userData.firstName} <span className="separator">|</span> {userData.employeeId}</p>
                </div>
                <div className="nav-center-progress">
                    <div className="progress-label">System Progress</div>
                    <div className="nav-progress-circle">
                        <svg viewBox="0 0 36 36">
                            <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                            <path className="circle" strokeDasharray={`${progress}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                        </svg>
                        <span className="percent-text">{progress}%</span>
                    </div>
                </div>
                <button 
                    className={`final-submit-btn ${progress === 100 ? 'ready' : ''}`} 
                    disabled={progress < 100}
                    onClick={transmitData}
                >
                    {progress === 100 ? 'UPLOAD LOGS' : 'INCOMPLETE'}
                </button>
            </div>

            <div className="ees-main-stage">
                <div className="category-sidebar">
                    {surveyData.map((item, index) => (
                        <button 
                            key={index} 
                            className={`cat-btn ${activeTab === index ? 'active' : ''}`}
                            onClick={() => setActiveTab(index)}
                        >
                            <span className="icon">{item.icon}</span>
                            <span className="label">{item.cat}</span>
                            {activeTab === index && <div className="active-glow"></div>}
                        </button>
                    ))}
                </div>

                <div className="question-stage">
                    <div className="stage-header">
                        <div className="title-group">
                            <small>DATA SECTOR {activeTab + 1}</small>
                            <h1>{surveyData[activeTab].cat}</h1>
                        </div>
                        <div className="stage-stats">
                            {surveyData[activeTab].questions.filter((_, i) => responses[`${activeTab}-${i}`]).length} / {surveyData[activeTab].questions.length} Complete
                        </div>
                    </div>
                    
                    <div className="question-grid-container">
                        {surveyData[activeTab].questions.map((q, i) => (
                            <div key={i} className={`glass-q-card ${responses[`${activeTab}-${i}`] ? 'answered' : ''}`}>
                                <div className="q-card-header">
                                    <span className="q-number">{(activeTab * 10) + i + 1}</span>
                                    <p>{q}</p>
                                </div>
                                <div className="rating-bubbles">
                                    {[1, 2, 3, 4, 5].map(num => (
                                        <button 
                                            key={num}
                                            className={`bubble bubble-${num} ${responses[`${activeTab}-${i}`] === num ? 'selected' : ''}`}
                                            onClick={() => handleSelect(i, num)}
                                        >
                                            {num}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EESExperience;